'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      id: 'faq_1',
      question: 'Wie lange dauert eine Firmengründung in Dubai?',
      answer:
        'Der Gründungsprozess dauert in der Regel 2-4 Wochen, abhängig von der gewählten Unternehmensstruktur und der Vollständigkeit Ihrer Unterlagen. Free Zone-Gründungen sind oft schneller als Mainland-Gründungen. Wir begleiten Sie durch jeden Schritt und sorgen für einen reibungslosen Ablauf.',
    },
    {
      id: 'faq_2',
      question: 'Muss ich für die Firmengründung in Dubai sein?',
      answer:
        'Nein, viele Schritte können aus dem Ausland erledigt werden. Für bestimmte Behördengänge und die Visa-Beantragung ist jedoch eine kurze Anwesenheit in Dubai erforderlich (ca. 3-5 Tage). Wir koordinieren alle Termine so, dass Sie nur einmal anreisen müssen.',
    },
    {
      id: 'faq_3',
      question: 'Welche Kosten entstehen für Ihre Dienstleistungen?',
      answer:
        'Die Kosten variieren je nach Umfang der gewünschten Leistungen. Das Erstgespräch ist kostenlos. Danach erstellen wir ein transparentes Angebot basierend auf Ihren spezifischen Anforderungen. Es gibt keine versteckten Gebühren – Sie wissen von Anfang an, was auf Sie zukommt.',
    },
    {
      id: 'faq_4',
      question: 'Wie läuft die Beratung ab?',
      answer:
        'Nach Ihrer Kontaktaufnahme vereinbaren wir ein kostenloses 30-minütiges Erstgespräch (telefonisch, per Video-Call oder persönlich in Dubai). Dabei besprechen wir Ihre Ziele und klären erste Fragen. Anschließend entwickeln wir gemeinsam eine maßgeschneiderte Strategie und begleiten Sie durch die Umsetzung.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-32 px-6 md:px-10 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-20 fade-in-up will-animate">
          <span className="text-accent text-xs font-bold uppercase tracking-ultra mb-6 block">
            Häufige Fragen
          </span>
          <h2 className="font-serif text-4xl md:text-6xl font-light tracking-tight">
            FAQ
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="card-luxury overflow-hidden fade-in-up will-animate"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-8 text-left hover:bg-background/50 transition-colors"
              >
                <h4 className="font-serif text-xl font-medium text-foreground pr-8">
                  {faq.question}
                </h4>
                <Icon
                  name={openIndex === index ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={24}
                  className="text-accent flex-shrink-0"
                />
              </button>

              {openIndex === index && (
                <div className="px-8 pb-8 pt-0">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}